import toNumber from "lodash/toNumber"
import map from "lodash/map"
import isEmpty from "lodash/isEmpty"
import { useState, useEffect } from "react"
import { makeStyles } from "tss-react/mui"
import Box from "component-lib/Base/components/Box"
import { Link } from "component-lib/Base"
import "./BreadcrumbStandalone.scss"

const useStyles = makeStyles()((theme) => ({
  textCrumbClass: {
    "&&": {
      "& .slash": {
        color: `${theme.palette.common.black} !important`,
      },
      "&:disabled": {
        opacity: 1,
        color: `${theme.palette.common.black} !important`,
      },
    },
  },
}))

const isNextApp = process.env.NEXT_PUBLIC_APP

const BreadcrumbStandalone = ({ breadcrumbList = [], customClass = `` }) => {
  const [reformedList, setReformedList] = useState({})

  const createList = () => {
    const newList = {}
    map(breadcrumbList, (crumb) => {
      newList[toNumber(crumb.level)] = crumb
    })
    return newList
  }

  const list = isNextApp ? createList() : reformedList

  useEffect(() => {
    const newList = createList()
    setReformedList(newList)
  }, [])

  const { classes } = useStyles()

  return (
    <Box
      data-testid="BreadcrumbStandalone"
      className="BreadcrumbStandaloneComponent"
    >
      <Box
        className={`container pt-4 ${customClass}`}
        display="flex"
        flexWrap="wrap"
      >
        {!isEmpty(list) &&
          map(list, ({ level, label, path, analyticsKey, isExternalLink }) => {
            const isText = !path
            return (
              label && (
                <Box
                  key={`${path}-${label}`}
                  className="crumb"
                  display="flex"
                  alignItems="baseline"
                >
                  <Link
                    className={`${classes.textCrumbClass}  wm-link maax-font-weight-bold`}
                    isExternalLink={isExternalLink}
                    href={path}
                    analytics_key={analyticsKey || label}
                    disabled={isText}
                  >
                    {label}
                    <span className="slash mx-1" style={{}}>
                      {breadcrumbList.length !== toNumber(level) ? `>` : ``}
                    </span>
                    {isText ? <span className="sr-only">{label}</span> : ``}
                  </Link>
                </Box>
              )
            )
          })}
      </Box>
    </Box>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// BreadcrumbStandalone.propTypes = {
//   /** breadcrumbList > Repeating Links - Destination pages */
//   breadcrumbList: PropTypes.arrayOf(
//     PropTypes.shape({
//       /** Breadcrumb Level - Breadcrumb position */
//       level: PropTypes.string.isRequired,
//       /** Breadcrumb Label - Breadcrumb link text */
//       label: PropTypes.string.isRequired,
//       /** Breadcrumb path - Breadcrumb link path */
//       path: PropTypes.string,
//       analyticsKey: PropTypes.string,
//       isExternalLink: PropTypes.bool,
//     }),
//   ),
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// BreadcrumbStandalone.defaultProps = {
//   breadcrumbList: [],
// }

export default BreadcrumbStandalone
